"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ENTITIES = exports.AIRTM_AUTHORITY = void 0;
exports.AIRTM_AUTHORITY = 'airtm';
exports.ENTITIES = {
    USER: 'user',
    GUEST: 'guest',
    NON_MIGRATED_USER: 'non-migrated-user',
};
